var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.55 28.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.7 0 C 11.1477 0 10.7 0.4477 10.7 1 L 10.7 10.7 L 1 10.7 C 0.4477 10.7 0 11.1477 0 11.7 L 0 16.85 C 0 17.4023 0.4477 17.85 1 17.85 L 10.7 17.85 L 10.7 27.55 C 10.7 28.1023 11.1477 28.55 11.7 28.55 L 16.85 28.55 C 17.4023 28.55 17.85 28.1023 17.85 27.55 L 17.85 17.85 L 27.55 17.85 C 28.1023 17.85 28.55 17.4023 28.55 16.85 L 28.55 11.7 C 28.55 11.1477 28.1023 10.7 27.55 10.7 L 17.85 10.7 L 17.85 1 C 17.85 0.4477 17.4023 0 16.85 0 Z",
    fill: "rgba(255, 255, 255, 0.03)",
    filter: "url(#glow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.7 0 C 11.1477 0 10.7 0.4477 10.7 1 L 10.7 10.7 L 1 10.7 C 0.4477 10.7 0 11.1477 0 11.7 L 0 16.85 C 0 17.4023 0.4477 17.85 1 17.85 L 10.7 17.85 L 10.7 27.55 C 10.7 28.1023 11.1477 28.55 11.7 28.55 L 16.85 28.55 C 17.4023 28.55 17.85 28.1023 17.85 27.55 L 17.85 17.85 L 27.55 17.85 C 28.1023 17.85 28.55 17.4023 28.55 16.85 L 28.55 11.7 C 28.55 11.1477 28.1023 10.7 27.55 10.7 L 17.85 10.7 L 17.85 1 C 17.85 0.4477 17.4023 0 16.85 0 Z",
    fill: "rgba(0, 0, 0, 0.08)",
    filter: "url(#shadow)",
    transform: "translate(0, 0.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.7 0 C 11.1477 0 10.7 0.4477 10.7 1 L 10.7 10.7 L 1 10.7 C 0.4477 10.7 0 11.1477 0 11.7 L 0 16.85 C 0 17.4023 0.4477 17.85 1 17.85 L 10.7 17.85 L 10.7 27.55 C 10.7 28.1023 11.1477 28.55 11.7 28.55 L 16.85 28.55 C 17.4023 28.55 17.85 28.1023 17.85 27.55 L 17.85 17.85 L 27.55 17.85 C 28.1023 17.85 28.55 17.4023 28.55 16.85 L 28.55 11.7 C 28.55 11.1477 28.1023 10.7 27.55 10.7 L 17.85 10.7 L 17.85 1 C 17.85 0.4477 17.4023 0 16.85 0 Z",
    fill: "rgba(255, 255, 255, 0.15)",
    stroke: "rgba(255, 255, 255, 0.2)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 1 11.2 C 0.7239 11.2 0.5 11.4239 0.5 11.7 L 0.5 11.7 M 0.5 11.7 L 0.5 11.2 C 0.5 10.9239 0.7239 10.7 1 10.7 L 10.7 10.7 L 10.7 1 C 10.7 0.4477 11.1477 0 11.7 0 L 11.7 0",
    fill: "none",
    stroke: "rgba(255, 255, 255, 0.15)",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.7 0 L 16.85 0 C 17.4023 0 17.85 0.4477 17.85 1 L 17.85 1",
    fill: "none",
    stroke: "rgba(255, 255, 255, 0.15)",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.85 10.7 L 27.55 10.7 C 28.1023 10.7 28.55 11.1477 28.55 11.7 L 28.55 11.7",
    fill: "none",
    stroke: "rgba(255, 255, 255, 0.15)",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassPlus);
export default __webpack_public_path__ + "static/media/glassPlus.fd0f80fd665e85529125a890d3c1c454.svg";
export { ForwardRef as ReactComponent };